import { Box, Typography } from '@mui/material'

import Space from 'components/Space'
import { SectionHeaderProps } from './types'

export const SectionHeader = ({
  subtitle,
  subtitleEndAdornment,
  title,
  titleEndAdornment,
}: SectionHeaderProps): JSX.Element => (
  <Box data-cy='section-header'>
    <Typography
      alignItems='center'
      display='flex'
      variant='h5'
    >
      {title}

      {titleEndAdornment && <Space />}
      {titleEndAdornment}
    </Typography>

    <Typography
      sx={{ whiteSpace: 'pre-line' }}
      variant='subtitle1'
    >
      {subtitle}

      {subtitleEndAdornment && <Space />}
      {subtitleEndAdornment}
    </Typography>
  </Box>
)
